import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class CashRoundingDropdown extends Component {

  render() {

    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
      preload = true,
      defaultDropdownMsg,
    } = this.props;
    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='cash_rounding'
          type='cash_rounding'
          valueField='id'
          component={ multiple ? renderSearchMultipleDropdown : renderSearchDropDown }
          onPostChange={onPostChange}
          preload={preload}
          defaultDropdownMsg={defaultDropdownMsg}
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(CashRoundingDropdown);
